module.exports = __webpack_public_path__ + "static/UNITY-SQUARE-One-traditional-a7d477f6bf60c4387cfc117bb7e4b7da.pdf";